import { render, staticRenderFns } from "./LabParametro.vue?vue&type=template&id=2b43c318&"
import script from "./LabParametro.vue?vue&type=script&lang=js&"
export * from "./LabParametro.vue?vue&type=script&lang=js&"
import style0 from "./LabParametro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports